module.exports = __webpack_public_path__ + "static/media/DuplicateSans-HeavyItalic.d8c63502.woff";